import React from 'react';

import { IFormGroupFields } from '@/types/contentful';

import { Flexbox } from '../../Flexbox';
import { Text } from '../../Text';

import { FormField } from './FormField';

interface FormGroupProps extends IFormGroupFields {
  state: any;
  errors: any;
  handleOnChange: (key: string, val: any) => void;
}

export function FormGroup({
  id,
  state,
  errors,
  formFields,
  sectionHeader,
  handleOnChange
}: FormGroupProps) {
  return (
    <Flexbox flexDirection="column">
      {sectionHeader && (
        <Text
          as="h5"
          fontSize="sm"
          lineHeight="s"
          fontWeight="500"
          marginTop="m"
          marginBottom="ml"
          padding={{ 0: [0, 's'] }}
        >
          {sectionHeader}
        </Text>
      )}

      {formFields.map(({ sys, fields }: any) => (
        <FormField
          {...fields}
          key={sys?.id}
          state={state}
          errors={errors}
          formGroupId={id}
          handleOnChange={handleOnChange}
        />
      ))}
    </Flexbox>
  );
}
